import Vue from 'vue';
import App from './App.vue';
import './assets/css/main.css';
import VueFlags from '@growthbunker/vueflags';
import i18n from './i18n';
import store from './store';
import VueMeta from 'vue-meta';
import VTooltip from 'v-tooltip';
import Toasted from 'vue-toasted';

Vue.config.productionTip = false;

Vue.use(VTooltip);
Vue.use(VueMeta);
Vue.use(VueFlags, {
  iconPath: '/flags/'
});
Vue.use(Toasted, {
  theme: 'bubble',
  position: 'bottom-center',
  className: 'ravenol-toast',
  duration: 3000
});

new Vue({
  i18n,
  store,
  render: h => h(App)
}).$mount('#app');
